module.exports = __webpack_public_path__ + "img/bao.e04f48c3.png";